import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { FooterComponent } from '../layout/footer.component';

@Component({
  selector: 'app-sso-layout',
  imports: [FooterComponent, RouterModule],
  template: `
    <div
      class="tw-flex bg-section tw-bg-[var(--sed-grey-20-color)] tw-w-full tw-flex-col tw-min-h-screen tw-p-4 sm:tw-p-8"
    >
      <main
        id="main-content"
        role="main"
        class="tw-grow tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6"
      >
        <div
          class="tw-flex-col tw-flex-none tw-w-full sm:tw-w-auto logo tw-pt-16 tw-pb-16"
        >
          <img src="assets/images/omni-logo-large.webp" alt="Omni Logo" />
        </div>
        <div class="tw-pb-16 tw-flex-col tw-w-full sm:tw-w-auto tw-flex-none">
          <div class="login-card tw-w-full sm:tw-w-[400px]">
            <router-outlet></router-outlet>
          </div>
        </div>
      </main>
      <div class="tw-w-full tw-p-4 tw-md:p-5">
        <app-footer
          [transparent]="true"
          [whatsNew]="true"
          [showFooterLogo]="false"
          [showFooterText]="true"
          [techSupportLiveChat]="true"
        />
      </div>
    </div>
  `,
  styles: `
    .logo {
      height: 38px;
    }
    .login-card {
      background-color: var(--sed-warm-white-color);
      width: 100%;
      min-width: 400px;
      border-radius: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      padding: 16px;
    }
    .bg-section {
      background: url('/assets/images/omni-background.webp') 50%
        calc(100% + 20px) / cover no-repeat;
    }

    .login-page {
      overflow-x: hidden;
    }

    .login-card,
    .login-card-inner,
    .login-form-wrapper {
      overflow-x: hidden;
      min-width: 0;
      box-sizing: border-box;
    }

    .login-form-wrapper > * {
      min-width: 0;
      max-width: 100%;
    }

    .login-logo {
      max-width: 100%;
      height: auto;
    }
  `,
})
export class SsoLayoutComponent extends BaseComponent {}
